module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-3.28635f51.svg";